import styled from "styled-components";

const Icon = styled.div`
  min-height: 48px;
  width: 48px;
  font-size: 1.5em;
  background: #ffb81c;
  border-radius: 0 0.5em 0 0.5em;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Label = styled.div`
  padding-top: 12px;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #5e514d;
  text-align: center;
  flex-shrink: 0;

  @media (max-width: 576px) {
    padding-top: 9.37px;
    font-size: 12px;
  }
`;

const Container = styled.div`
  width: 128px;
  min-height: 128px;
  text-align: -webkit-center;
  padding: 24px 0;
  border-radius: 0 1em 0 1em;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 576px) {
    width: 100px;
    min-height: 100px;
    padding: 18.75px 0;
  }

  &:hover {
    background: #0000000a;
    cursor: pointer;
  }

  &:hover ${Icon} {
    box-shadow: 10px 10px 10px #ffb81c30;
  }
`;

const ButtonMenu = function (props) {
  return (
    <Container>
      <Icon>
        <props.icon
          fill={props.fill}
          height="24px"
          width="24px"
          style={{ height: "-webkit-fill-available" }}
        />
      </Icon>
      <Label>{props.label}</Label>
    </Container>
  );
};

export default ButtonMenu;
